module.exports = __webpack_public_path__ + "r-v3/img/layout_white.042ec578.svg";